import * as React from 'react';
import { BaseComponent } from '../BaseComponent';
import { SelectBoxOption } from '../../stores/SelectBoxStore';
import { PopupFlagPosition } from '../../constants/PopupFlagPositions';
import { BasePopupMenuTitleSetting } from './BasePopupMenuHeader';
import { BasePopupMenuContentProps, BasePopupMenuContent } from './BasePopupMenuContent';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';

export interface BasePopupMenuProps {
    options: Array<SelectBoxOption>;
    className: string;
    toggleCallback: (pValue: boolean) => void;
    open: boolean;
    flagPosition: PopupFlagPosition;
    defaultValue: any;
    title: BasePopupMenuTitleSetting;
    changeCallback?: (pValue: any) => void; // if not set, options must have own callback functions
    transform?: boolean;
}

export interface BasePopupMenuState {
    open: boolean;
}

export class BasePopupMenu extends BaseComponent<BasePopupMenuProps, BasePopupMenuState> {
    get open(): boolean {
        if (this.props.open == null) {
            return this.state.open;
        }
        return this.props.open;
    }

    protected openState: boolean = false;

    public render(): JSX.Element {
        return (
            <div className={this.props.className + ' egr-selectbox' + (this.props.open ? ' active-button-state' : '')} onClick={this.toggle}>
                {(AppConfigurationStore.getState().touchDevice && this.props.className) ? <div className="select-hider"/> : null}
                <BasePopupMenuContent {...this.contentProps()}/>
                {this.props.children}
            </div>
        );
    }

    public componentWillMount(): void {
        this.setState({open: false});
    }

    protected toggle = (pEvent: React.MouseEvent | React.TouchEvent): void => {
        if (this.props.toggleCallback) {
            this.props.toggleCallback(this.open);
        }
        if (this.props.open == null) {
            this.setState({open: !this.state.open});
        }
    };

    protected contentProps = (): BasePopupMenuContentProps => {
        return {
            flagPosition: this.props.flagPosition,
            defaultValue: this.props.defaultValue,
            open: this.open,
            options: this.props.options,
            title: this.props.title,
            changeCallback: this.props.changeCallback,
            transform: this.props.transform
        };
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/popupmenu/BasePopupMenu.tsx